import React from 'react';
import { Trans } from 'react-i18next';
import { useTranslation } from '../../i18n/hooks/useTranslation';
import { version as APP_VERSION } from '../../../version.json';

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const links = [
    { key: 'terms', label: t('footer.terms'), href: 'https://sohozkaj.com/terms' },
    { key: 'privacy', label: t('footer.privacy'), href: 'https://sohozkaj.com/privacy' },
    { key: 'copyright', label: t('footer.copyrightLink'), href: 'https://sohozkaj.com/copyright' },
    { key: 'refundPolicy', label: t('footer.refundPolicy'), href: 'https://sohozkaj.com/refund-policy' },
  ];

  return (
    // Full-bleed: break out of the container to span the full viewport width, then
    // re-center the content with an inner max-width wrapper.
    <footer
      className="mt-2 lg:mt-5 border-t border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-900"
      style={{ marginLeft: 'calc(-50vw + 50%)', marginRight: 'calc(-50vw + 50%)' }}
    >
      <div className="max-w-container mx-auto flex items-center justify-between gap-3.5 flex-wrap px-4 sm:px-6 py-2">
        {/* Copyright */}
        <div className="flex items-center gap-2.5">
          <img src="/images/favicon.svg" alt="SohozKaj" className="w-5 flex-shrink-0" />
          <span className="text-[11px] leading-none text-zinc-500 dark:text-zinc-400 mt-[3px] inline-block">
            <Trans
              i18nKey="footer.copyright"
              values={{ year }}
              components={{
                company: (
                  <a
                    href="https://sigmative.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary no-underline font-semibold tracking-wide transition-colors"
                  />
                ),
              }}
            />
            <span className="text-zinc-300 dark:text-zinc-600 mx-1.5">·</span>
            <span className="text-zinc-400 dark:text-zinc-500">v{APP_VERSION}</span>
          </span>
        </div>

        {/* Links */}
        <div className="flex items-center gap-3 text-[10px] text-zinc-400 dark:text-zinc-500">
          {links.map(({ key, label, href }) => (
            <a
              key={key}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-zinc-600 dark:hover:text-zinc-300 transition-colors"
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;